import { Link } from 'react-router';
import { Card } from '@heroui/react';

/**
 * The router's `path: '*'` catch-all, and the only route that can be reached
 * without meaning to.
 *
 * The link out is load-bearing rather than decorative: inside the Mini App
 * there is no address bar to retype a URL into, so a 404 without one is a dead
 * end that can only be left by closing the app.
 */
export function NotFoundPage() {
  return (
    // The centring wrapper is a copy of `Centered` in components/guards.tsx —
    // the three standalone pages (sign-in, not-a-member, this one) render
    // outside AppShell and have to line up with the guard screens the router
    // shows in their place.
    <div className="grid min-h-dvh place-items-center bg-background px-4 py-6 text-foreground">
      <Card className="w-full max-w-md">
        <Card.Header>
          <Card.Title className="text-xl">Страница не найдена</Card.Title>
          <Card.Description>По этому адресу ничего нет.</Card.Description>
        </Card.Header>

        <Card.Content>
          <Link to="/" className="text-sm text-link underline underline-offset-2">
            Вернуться к обзору
          </Link>
        </Card.Content>
      </Card>
    </div>
  );
}
